import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/common/recommend/getList',
        method: 'post',
        data: data
    })
}
export function add(data) {
    return request({
        url: '/backend/common/recommend/add',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/common/recommend/delete',
        method: 'post',
        data: data
    })
}